(function(){
  function nlUpdateShipBar(){
    fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      var thr=4995;
      document.querySelectorAll('.nl-ship2').forEach(function(bar){
        var pct=cart.total_price>=thr?100:Math.round(cart.total_price*100/thr);
        var rem=thr-cart.total_price;
        var fill=bar.querySelector('.nl-ship2__fill');
        var msg=bar.querySelector('.nl-ship2__msg');
        if(fill){fill.style.width=pct+'%';fill.classList.toggle('nl-ship2__fill--done',cart.total_price>=thr);}
        if(msg){
          if(cart.total_price>=thr){msg.className='nl-ship2__msg nl-ship2__msg--done';msg.innerHTML='<em class="nl-ship2__icon">&#x2713;</em> Je hebt gratis verzending!';}
          else{msg.className='nl-ship2__msg';var e=Math.floor(rem/100);var c=('0'+(rem%100)).slice(-2);msg.innerHTML='Nog <strong>€'+e+','+c+'</strong> tot gratis verzending';}
        }
      });
      document.querySelectorAll('.totals__total-value').forEach(function(el){
        var e=Math.floor(cart.total_price/100);var c=('0'+(cart.total_price%100)).slice(-2);
        el.textContent='€'+e+','+c+' EUR';
      });
      document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function(el){el.textContent=cart.item_count;});
      document.querySelectorAll('.cart-count-bubble').forEach(function(b){b.classList.remove('hidden');});
    }).catch(function(){});
  }

  function initPubSub(){
    if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS==='object' && PUB_SUB_EVENTS.cartUpdate){
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(){
        setTimeout(nlUpdateShipBar, 150);
      });
    } else {
      setTimeout(initPubSub, 200);
    }
  }
  initPubSub();

  var mo = new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){
      if(muts[i].type==='childList' && muts[i].target.id==='CartDrawer-CartItems'){
        setTimeout(nlUpdateShipBar, 200);
        break;
      }
    }
  });
  function observeCartItems(){
    var el=document.getElementById('CartDrawer-CartItems');
    if(el) mo.observe(el,{childList:true,subtree:false});
    else setTimeout(observeCartItems, 500);
  }
  observeCartItems();

  document.querySelectorAll('.js-contents').forEach(function(el){
    new MutationObserver(function(){ setTimeout(nlUpdateShipBar, 200); })
      .observe(el, {childList:true, subtree:false});
  });

  document.addEventListener('click',function(e){
    var ab = e.target.closest('.nl-cs__add');
    if (ab) {
      e.preventDefault();
      var v = ab.dataset.variantId;
      if (!v) return;
      ab.textContent = '...'; ab.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(v), quantity: 1 }] })
      })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (response) {
        ab.textContent = 'Toegevoegd!';
        ab.classList.add('nl-cs__add--added');
        nlUpdateShipBar();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nl-cross-sell', productVariantId: v, cartData: response });
        }
      })
      .catch(function () { ab.textContent = 'Niet beschikbaar'; ab.disabled = true; });
      return;
    }
    var dt=e.target.closest('.nl-disc__toggle');
    if(dt){var fm=dt.parentElement.querySelector('.nl-disc__form');if(fm){fm.classList.toggle('is-open');if(fm.classList.contains('is-open')){var ip=fm.querySelector('.nl-disc__input');if(ip)setTimeout(function(){ip.focus();},100);}}return;}
    var da=e.target.closest('.nl-disc__btn');
    if(da){var i2=da.parentElement.querySelector('.nl-disc__input');if(i2){var cd=i2.value.trim();if(cd)window.location.href='/discount/'+encodeURIComponent(cd)+'?redirect=/cart';}return;}
  });
  document.addEventListener('keydown',function(e){if(e.target.classList.contains('nl-disc__input')&&e.key==='Enter'){e.preventDefault();var b=e.target.parentElement.querySelector('.nl-disc__btn');if(b)b.click();}});
  var se=null;
  document.addEventListener('mousedown',function(e){var s=e.target.closest('.nl-cs__scroll');if(!s||e.target.closest('.nl-cs__add'))return;se=s;se._sx=e.pageX;se._sl=s.scrollLeft;se.style.cursor='grabbing';});
  document.addEventListener('mousemove',function(e){if(!se)return;e.preventDefault();se.scrollLeft=se._sl-(e.pageX-se._sx);});
  document.addEventListener('mouseup',function(){if(se){se.style.cursor='grab';se=null;}});
  document.addEventListener('wheel',function(e){var s=e.target.closest('.nl-cs__scroll');if(!s||Math.abs(e.deltaX)>Math.abs(e.deltaY))return;e.preventDefault();s.scrollLeft+=e.deltaY;},{passive:false});
})();
